import { DataProvider, GetListParams, GetListResult } from 'react-admin';
import { complaintsProxy } from './apiGateway';

interface Complaint {
    id: string;
    lastUpdatedDate: string;
    complaintType: string;
    complaintStatus: 'NEW' | 'IN_PROGRESS' | 'REJECTED' | 'APPLIED';
    meta?: {
        cursor?: string | null;
    };
}

interface ComplaintDetail {
    id: string;
    adId: string;
    createdDate: string;
    lastUpdatedDate: string;
    complaintType: string;
    reportMessage: string;
    reporterUser: {
        userId: string;
        username: string;
        avatarUrl: string | null;
    };
    currentComplaintStatus: 'NEW' | 'IN_PROGRESS' | 'REJECTED' | 'APPLIED';
    statusHistory: Array<{
        status: string;
        date: string;
        result?: {
            commentFromModerator: string;
            moderatorId: string;
        };
    }>;
    result?: {
        commentFromModerator: string;
        moderatorId: string;
    } | null;
    youTrackIssueUrl?: string | null;
}

interface ComplaintStatusUpdate {
    complaintStatusResult: 'IN_PROGRESS' | 'REJECTED' | 'APPLIED';
    comment?: string;
    youTrackIssueUrl?: string;
}

interface ComplaintsApiResponse {
    success: boolean;
    body: {
        response: Complaint[];
        cursor?: string | null;
    };
}

export const complaintsDataProvider = {
    getList: async (_resource: string, params: GetListParams): Promise<GetListResult<Complaint>> => {
        const json: ComplaintsApiResponse = await complaintsProxy.getList(params);
        const complaints = json.body.response.map(complaint => ({
            ...complaint,
            meta: { cursor: json.body.cursor || null }
        }));
        return {
            data: complaints,
            total: complaints.length,
            pageInfo: {
                hasNextPage: !!json.body.cursor,
                hasPreviousPage: false
            },
            meta: {
                cursor: json.body.cursor || null
            }
        };
    },
    getOne: async (_resource: string, params: { id: string }) => {
        const json = await complaintsProxy.getOne(params.id);
        return {
            data: json.body
        };
    },
    update: async (_resource: string, params: { id: string; data: any }) => {
        const json = await complaintsProxy.updateStatus(params.id, params.data);
        return {
            data: json.body
        };
    },
    getMany: async () => Promise.resolve({ data: [] }),
    getManyReference: async () => Promise.resolve({ data: [] }),
    create: async () => Promise.reject('Not implemented'),
    updateMany: async () => Promise.reject('Not implemented'),
    delete: async () => Promise.reject('Not implemented'),
    deleteMany: async () => Promise.reject('Not implemented')
} as DataProvider;
